/* spx-collapse-lite.js (2026-07-05) — replaces the 60KB Bootstrap bundle.
   The theme uses exactly ONE Bootstrap behavior: Collapse (header drawer
   accordions + FAQ/spec accordions, via data-bs-toggle="collapse").
   This implements that subset against Bootstrap's own CSS classes
   (.collapse / .collapsing / .show from sp-bootstrap-custom.min.css),
   including data-bs-parent accordion grouping and aria-expanded.
   No events are dispatched — grep confirmed nothing listens for *.bs.collapse. */
(function () {
  'use strict';
  var TRANSITION_MS = 400; /* safety fallback past Bootstrap's 350ms */

  function targetsOf(trigger) {
    var sel = trigger.getAttribute('data-bs-target') || trigger.getAttribute('href') || '';
    if (!sel || sel === '#') return [];
    try { return [].slice.call(document.querySelectorAll(sel)); } catch (e) { return []; }
  }

  function setExpanded(el, expanded) {
    var sel = '[data-bs-toggle="collapse"][data-bs-target="#' + el.id + '"], [data-bs-toggle="collapse"][href="#' + el.id + '"]';
    [].forEach.call(document.querySelectorAll(sel), function (t) {
      t.classList.toggle('collapsed', !expanded);
      t.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    });
  }

  function afterTransition(el, fn) {
    var done = false;
    var finish = function () { if (done) return; done = true; el.removeEventListener('transitionend', finish); fn(); };
    el.addEventListener('transitionend', finish);
    setTimeout(finish, TRANSITION_MS);
  }

  function expand(el) {
    if (el.classList.contains('collapsing') || el.classList.contains('show')) return;
    var parentSel = el.getAttribute('data-bs-parent');
    if (parentSel) {
      try {
        var parent = document.querySelector(parentSel);
        if (parent) {
          [].forEach.call(parent.querySelectorAll('.collapse.show'), function (open) {
            if (open !== el) collapse(open);
          });
        }
      } catch (e) {}
    }
    el.classList.remove('collapse');
    el.classList.add('collapsing');
    el.style.height = '0px';
    void el.offsetHeight; /* reflow */
    el.style.height = el.scrollHeight + 'px';
    afterTransition(el, function () {
      el.classList.remove('collapsing');
      el.classList.add('collapse', 'show');
      el.style.height = '';
    });
    setExpanded(el, true);
  }

  function collapse(el) {
    if (el.classList.contains('collapsing') || !el.classList.contains('show')) return;
    el.style.height = el.getBoundingClientRect().height + 'px';
    void el.offsetHeight;
    el.classList.remove('collapse', 'show');
    el.classList.add('collapsing');
    el.style.height = '';
    afterTransition(el, function () {
      el.classList.remove('collapsing');
      el.classList.add('collapse');
    });
    setExpanded(el, false);
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest ? e.target.closest('[data-bs-toggle="collapse"]') : null;
    if (!trigger) return;
    var targets = targetsOf(trigger);
    if (!targets.length) return;
    if (trigger.tagName === 'A') e.preventDefault();
    targets.forEach(function (el) {
      if (el.classList.contains('show')) collapse(el);
      else expand(el);
    });
  });
})();
